module.exports = __webpack_public_path__ + "img/support_phone.c474fd7f.png";